//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.LineWeldDataBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ArrowSideWeldData",0,"Annotations.LineWeldDataBuilder",0],[0,"FieldWeld",1,0],[0,"FlipDirection",1,0],[0,"FlipHorizontal",1,0],[0,"FlipVertical",1,0],[0,"ForeshorteningSymbol",0,"Annotations.ForeshorteningSymbolBuilder",0],[0,"IdLine",1,0],[1,"Inherit",0,"SelectDisplayableObject",0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"OtherSideWeldData",0,"Annotations.LineWeldDataBuilder",0],[0,"Scale",1,0],[1,"SideSeamObjects",0,"SelectDisplayableObjectList",0],[0,"SpaceFactor",1,0],[0,"StaggeredWeld",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"Tail",1,0],[1,"TopSeamObject",0,"SelectDisplayableObject",0],[0,"WeldAlongContour",1,0]],[[["nReference"],"GetReference",{R_:{reference:""}},0,0],[["reference"],"SetReference",{},1,0],[["annotation"],"InheritProperties",{},1,0],[["feature"],"InheritPropertiesFromWeldFeature",{},1,0],[[],"CreatePreview",{R_:{previewObject:"Annotations.Weld"}},0,0],[["annotation"],"EditPreview",{},1,0]],[]];
SPLM.Annotations.LineWeldBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.LineWeldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.LineWeldBuilder.FieldWeldType = Object.freeze({
    "Plain" : "Plain", "TopField" : "TopField", "TopFieldSimpleFlag" : "TopFieldSimpleFlag"});

SPLM.Annotations.LineWeldBuilder.IdLineType = Object.freeze({
    "Plain" : "Plain", "IdLineAbove" : "IdLineAbove", "IdLineBelow" : "IdLineBelow", "CenteredSpotWeld" : "CenteredSpotWeld", "CenteredSeamWeld" : "CenteredSeamWeld", "Centered" : "Centered"});

SPLM.Annotations.LineWeldBuilder.StaggeredWeldType = Object.freeze({
    "NoStaggeredSymbol" : "NoStaggeredSymbol", "StaggeredSymbol" : "StaggeredSymbol", "StaggeredSymbolWeldSide" : "StaggeredSymbolWeldSide"});

SPLM.Annotations.LineWeldBuilder.TailType = Object.freeze({
    "NoTail" : "NoTail", "Tail" : "Tail", "Box" : "Box"});

SPLM.Annotations.LineWeldBuilder.WeldSymbolWeldAlongContourType = Object.freeze({
    "None" : "None", "Closed" : "Closed", "Unclosed" : "Unclosed", "TrilateralWeld" : "TrilateralWeld", "AllAround" : "AllAround"});

export default SPLM;